import React, {useState} from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import './styles/bookingform.css'; // Import your custom Sass styles

const ContactSection = () => {
  const [formData, setFormData] = useState({
      name: '',
      email: '',
      phone: '',
      message: ''
    });

    const [sending, setSending] = useState(false);
    const [message, setMessage] = useState('');
  
    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setSending(true);
      try {
        const response = await fetch('/api/book-call', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        });
        if (response.ok) {
          setMessage('Booking successfully submitted!');
          setFormData({ name: '', email: '', phone: '', message: ''});
        } else {
          setMessage('Failed to send booking. Please try again later.');
        }
      } catch (error) {
        console.error('Error:', error);
        setMessage('Failed to send booking. Please try again later.');
      } finally {
        setSending(false);
      }
    };

  return (
    <section className="contact-section">
      <Container>
        <h2>Contact Us</h2>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={4}>
              <Form.Group controlId="formName">
                <Form.Label>Name</Form.Label>
                <Form.Control value={formData.name}
                  name="name" onChange={handleChange} type="text" placeholder="Your Name" required />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group controlId="formEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control value={formData.email}
                  name="email" onChange={handleChange} type="email" placeholder="Your Email" required />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group controlId="formNumber">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control value={formData.phone}
                  name="phone" onChange={handleChange} type="phone" placeholder="Phone Number" required />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group controlId="formMessage">
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Your Message"
              value={formData.message}
              name="message"
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Button variant="primary" type="submit" disabled={sending}>
            {sending ? 'Sending...' : 'Submit Message'}
          </Button>
          {message && <p>{message}</p>}
        </Form>
        <footer className="contact-footer">
          <p>© 2025 InterWebb UK. All rights reserved.</p>
          <p>
            Follow us on{' '}
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              Twitter
            </a>{' '}
            |{' '}
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              Facebook
            </a>
          </p>
        </footer>
      </Container>
    </section>
  );
};

export default ContactSection;
